import { type FC } from 'react'
import cn from 'classnames'
import { twMerge } from 'tailwind-merge'
import { type DefaultProps } from '../common'

export const IconErrorCircleSolid: FC<DefaultProps> = ({ className, id, testId, ariaLabel }) => {
  const baseClass = cn('size-10 text-icons-error')
  const finalClasses = twMerge(baseClass, className)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
      className={finalClasses}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="currentColor"
      />
      <path
        d="M20 9C19.4477 9 19 9.44771 19 10V24C19 24.5523 19.4477 25 20 25C20.5523 25 21 24.5523 21 24V10C21 9.44771 20.5523 9 20 9Z"
        fill="white"
      />
      <path
        d="M20 29C19.4477 29 19 29.4477 19 30C19 30.5523 19.4477 31 20 31C20.5523 31 21 30.5523 21 30C21 29.4477 20.5523 29 20 29Z"
        fill="white"
      />
    </svg>
  )
}
